/**
 * @generated SignedSource<<17fc5251641c6a342b8c7842ed9bb888>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RunningTimeTrackWidget_timeTrack$data = {
  readonly associatedCustomer: {
    readonly category: {
      readonly note: string;
    } | null | undefined;
    readonly displayName: string;
    readonly id: string;
    readonly noticeText: string | null | undefined;
    readonly printName: string;
    readonly reference: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly note: string | null | undefined;
  readonly recordedStart: string | null | undefined;
  readonly title: string | null | undefined;
  readonly todo: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TimeTrackEditorDialog_timeTrack" | "TimeTrackRow_timeTrack" | "TimeTrackTimeChooserPopover_timeTrack">;
  readonly " $fragmentType": "RunningTimeTrackWidget_timeTrack";
};
export type RunningTimeTrackWidget_timeTrack$key = {
  readonly " $data"?: RunningTimeTrackWidget_timeTrack$data;
  readonly " $fragmentSpreads": FragmentRefs<"RunningTimeTrackWidget_timeTrack">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RunningTimeTrackWidget_timeTrack",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordedStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "associatedCustomer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "printName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reference",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noticeText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomerCategory",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "todo",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeTrackRow_timeTrack"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeTrackEditorDialog_timeTrack"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeTrackTimeChooserPopover_timeTrack"
    }
  ],
  "type": "TimeTrack",
  "abstractKey": null
};
})();

(node as any).hash = "0685a773f9f1ab7ebe440f6e7f73755a";

export default node;
